import type { Lead } from '../../../lib/api'
import { SectionBody, SectionHeader } from './StageContextLayout'

export function LiveContext(_props: { lead: Lead }) {
  return (
    <>
      <SectionHeader color="#d1fae5">
        <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#065f46' }}>Account Live & Processing</h3>
      </SectionHeader>
      <SectionBody>
        <p style={{ fontSize: '14px', color: '#065f46' }}>
          This merchant is actively processing transactions.
        </p>
      </SectionBody>
    </>
  )
}
